import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { Task, task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { not } from "ember-truth-helpers";
import { shape, instanceOf } from "prop-types";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import Select from "glesys-controlpanel/components/select";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GInput from "glesys-controlpanel/components/g-input";

@forbidExtraArgs
export default class ModalsCreateShipment extends Component {
  @service modal;
  @service ajax;

  @arg(
    shape({
      submitTask: instanceOf(Task),
    }).isRequired,
  )
  params;

  @tracked selectedDataCenter;
  @tracked trackingId;

  get dataCenters() {
    return [
      { value: "dc-fbg1", label: "Falkenberg" },
      { value: "dc-sto1", label: "Stockholm" },
    ];
  }

  onFormChange = ({ trackingId, dataCenter }) => {
    this.trackingId = trackingId;
    this.selectedDataCenter = dataCenter;
  };

  get canSubmit() {
    return this.selectedDataCenter;
  }

  onSubmitTask = task(async () => {
    let ok = await this.params.submitTask.perform(this.selectedDataCenter, this.trackingId);

    if (ok) {
      this.modal.close();
    }
  });

  <template>
    <Header>{{t "component.modal.create-shipment.title"}}</Header>
    <Body data-test-create-shipment-modal>
      <p class="text-gray-800 pb-6">
        {{t "component.modal.create-shipment.description"}}
      </p>
      <TaskForm id="create-shipment-form" @onChange={{this.onFormChange}} @task={{this.onSubmitTask}}>
        <div class="grid gap-4">
          <div>
            <Label for="dataCenter">{{t "label.data-center"}}</Label>
            <Select
              id="dataCenter"
              data-test-create-shipment-modal-datacenter
              name="dataCenter"
              @placeholder={{t "component.modal.create-shipment.data-center-placeholder"}}
              @items={{this.dataCenters}}
              @value={{this.selectedDataCenter}}
              required
            />
          </div>

          <div>
            <Label for="trackingId">{{t "label.tracking-id-optional"}}</Label>
            <GInput
              data-test-create-shipment-modal-tracking-id
              name="trackingId"
              value={{this.trackingId}}
              placeholder={{t "component.modal.create-shipment.tracking-id-placeholder"}}
            />
            {{#unless this.trackingId}}
              <p class="-mt-2 mb-2 text-xs text-gray-600" data-test-create-shipment-modal-no-tracking-number-hint>
                {{t "component.modal.create-shipment.no-tracking-number-hint"}}
              </p>
            {{/unless}}
          </div>
        </div>
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton
        data-test-create-shipment-submit
        @type="submit"
        @color="blue"
        @disabled={{not this.canSubmit}}
        form="create-shipment-form"
      >
        {{t "button.create"}}
      </GButton>
    </Footer>
  </template>
}
